import { useEffect } from 'react';

export const useElementKeyDown = (element, method, listeners) => {
	useEffect(() => {
		if (element) element.addEventListener('keydown', method);
		return () => element && element.removeEventListener('keydown', method);
	}, [...listeners]);
};

export const useElementMouseEnter = (element, method, listeners) => {
	useEffect(() => {
		if (element) element.addEventListener('mouseenter', method);
		return () => element && element.removeEventListener('mouseenter', method);
	}, [...listeners]);
};

export const useElementMouseLeave = (element, method, listeners) => {
	useEffect(() => {
		if (element) element.addEventListener('mouseleave', method);
		return () => element && element.removeEventListener('mouseleave', method);
	}, [...listeners]);
};

export const useElementHeight = (element, method, listeners) => {
	useEffect(() => {
		const observer = new ResizeObserver(entries => {
			const item = entries[0];
			method(item.contentRect.height);
		});
		if (element) observer.observe(element);
		return () => observer.disconnect();
	}, [...listeners]);
};
